module.exports = __webpack_public_path__ + "static/media/header.04288304.jpeg";